export default {
  '审图资料上传': '审图资料上传',
  '需要上传': '需要上传',
  '可选上传': '可选上传',
  '张': '张',
  '已上传': '已上传',
  '每张最大不超过10M': '每张最大不超过10M',
  '查看': '查看',
  '报图样板': '报图样板',
  '审核通过即不能进行修改': '审核通过即不能进行修改',
  '审核意见': '审核意见',
  '示例图片': '示例图片',
  '上传': '上传',
  '上一步': '上一步',
  '保存': '保存',
  '确认提交': '确认提交',
  '图片上传数量不足': '图片上传数量不足',
  '图片上传失败': '图片上传失败',
  '该展位下已存在有效的审图状态': '该展位下已存在有效的审图状态',
  '的图片总大小不能大于10M': '的图片总大小不能大于10M',
  '要求': '要求',
  '如需对图片进行说明，请点击': '如需对图片进行说明，请点击',
  '添加备注': '添加备注',
  '请添加备注': '请添加备注',
  '关闭': '关闭',
  '审核未通过': '审核未通过',
  '审核通过': '审核通过',
  '待审核': '待审核',
  '审核不通过的审图': '审核不通过的审图',
  '展开提交审图图纸': '展开提交审图图纸',
  '暂无示例图片': '暂无示例图片',
  "以下图纸将不会提交审核": "以下图纸将不会提交审核",
  '选填': '选填',

}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsUpload.js